(() => {
  const initializeFaqDirectories = (root = document) => {
    const directories = root.matches?.('[data-faq-directory]')
      ? [root]
      : root.querySelectorAll('[data-faq-directory]');

    directories.forEach((directory) => {
      if (directory.dataset.faqInitialized === 'true') return;
      directory.dataset.faqInitialized = 'true';

      const buttons = Array.from(directory.querySelectorAll('[data-faq-category-button]'));
      const items = Array.from(directory.querySelectorAll('[data-faq-item]'));
      const heading = directory.querySelector('[data-faq-group-heading]');

      if (!buttons.length || !items.length) return;

      let isSynchronizing = false;

      const closeOtherItems = (activeItem) => {
        if (!activeItem.open || isSynchronizing) return;
        isSynchronizing = true;
        items.forEach((item) => {
          if (item !== activeItem && !item.hidden) item.open = false;
        });
        isSynchronizing = false;
      };

      items.forEach((item) => {
        item.addEventListener('toggle', () => closeOtherItems(item));
      });

      const activateCategory = (button, updateUrl = true) => {
        const category = button.dataset.faqCategory;
        const label = button.dataset.faqLabel || button.textContent.trim();

        buttons.forEach((candidate) => {
          candidate.setAttribute('aria-pressed', String(candidate === button));
        });

        isSynchronizing = true;
        items.forEach((item) => {
          item.open = false;
          item.hidden = item.dataset.faqCategory !== category;
        });

        const firstVisibleItem = items.find((item) => !item.hidden);
        if (firstVisibleItem) firstVisibleItem.open = true;
        isSynchronizing = false;

        if (heading) heading.textContent = label;

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (category === directory.dataset.defaultCategory) {
            url.searchParams.delete('category');
          } else {
            url.searchParams.set('category', category);
          }
          window.history.replaceState({}, '', url);
        }
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => activateCategory(button));
      });

      const requestedCategory = new URL(window.location.href).searchParams.get('category');
      const requestedButton = requestedCategory
        ? buttons.find((button) => button.dataset.faqCategory === requestedCategory)
        : null;
      const defaultButton = buttons.find((button) => button.dataset.faqCategory === directory.dataset.defaultCategory)
        || buttons[0];

      activateCategory(requestedButton || defaultButton, false);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFaqDirectories());
  } else {
    initializeFaqDirectories();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeFaqDirectories(event.target);
  });
})();
